import { render, staticRenderFns } from "./lotto-results.vue?vue&type=template&id=90901b12"
import script from "./lotto-results.vue?vue&type=script&lang=js"
export * from "./lotto-results.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('90901b12')) {
      api.createRecord('90901b12', component.options)
    } else {
      api.reload('90901b12', component.options)
    }
    module.hot.accept("./lotto-results.vue?vue&type=template&id=90901b12", function () {
      api.rerender('90901b12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/lotto/lotto-results.vue"
export default component.exports